var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { addCardChrome, addTopSheen } from '../chrome';
import { getActiveDiagram } from '../theme';
export function createClassNode(app, name, attributes, methods) {
    var e_1, _a, e_2, _b;
    var width = 176;
    var lineH = 17;
    var headerH = 32;
    var bodyLines = attributes.length + methods.length;
    var height = headerH + bodyLines * lineH + (methods.length > 0 && attributes.length > 0 ? 8 : 4) + 6;
    var node = app.group();
    node.metadata.diagramCardWidth = width;
    node.metadata.diagramCardHeight = height;
    var radius = getActiveDiagram().radii.md;
    addCardChrome(app, node, {
        width: width,
        height: height,
        cornerRadius: radius,
        fill: getActiveDiagram().classFill,
        stroke: getActiveDiagram().classStroke,
        strokeWidth: getActiveDiagram().stroke.node,
        shadow: getActiveDiagram().shadowSoft,
        accentColor: getActiveDiagram().umlInheritance,
        sheen: false,
    });
    // Header band inset so square corners sit inside the rounded card stroke
    node.add(app.rect({
        x: Math.max(2, radius * 0.35),
        y: 3,
        width: width - Math.max(4, radius * 0.7),
        height: headerH - 4,
        fill: getActiveDiagram().classHeaderBg,
        stroke: null,
        listening: false,
    }));
    addTopSheen(app, node, width, radius);
    node.add(app.text({
        text: name,
        x: getActiveDiagram().spacing.sm,
        y: 10,
        fontSize: getActiveDiagram().fontSize.lg,
        fontWeight: 'bold',
        fontStyle: 'italic',
        fontFamily: getActiveDiagram().fontFamily,
        fill: getActiveDiagram().classHeader,
        listening: false,
    }));
    node.add(app.line({
        x: 0,
        y: headerH,
        x2: width,
        y2: 0,
        stroke: getActiveDiagram().classDivider,
        strokeWidth: getActiveDiagram().stroke.label,
        listening: false,
    }));
    var y = headerH + 4;
    try {
        for (var attributes_1 = __values(attributes), attributes_1_1 = attributes_1.next(); !attributes_1_1.done; attributes_1_1 = attributes_1.next()) {
            var attr = attributes_1_1.value;
            node.add(app.text({
                text: attr,
                x: getActiveDiagram().spacing.sm,
                y: y,
                fontSize: getActiveDiagram().fontSize.md,
                fontFamily: getActiveDiagram().fontMono,
                fill: getActiveDiagram().classBody,
                listening: false,
            }));
            y += lineH;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (attributes_1_1 && !attributes_1_1.done && (_a = attributes_1.return)) _a.call(attributes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (methods.length > 0 && attributes.length > 0) {
        node.add(app.line({
            x: 0,
            y: y - 2,
            x2: width,
            y2: 0,
            stroke: getActiveDiagram().classDivider,
            strokeWidth: getActiveDiagram().stroke.label,
            listening: false,
        }));
        y += 4;
    }
    try {
        for (var methods_1 = __values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()) {
            var method = methods_1_1.value;
            node.add(app.text({
                text: method,
                x: getActiveDiagram().spacing.sm,
                y: y,
                fontSize: getActiveDiagram().fontSize.md,
                fontFamily: getActiveDiagram().fontMono,
                fill: getActiveDiagram().classBody,
                listening: false,
            }));
            y += lineH;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (methods_1_1 && !methods_1_1.done && (_b = methods_1.return)) _b.call(methods_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return node;
}
